import PubSub from "underpub-js";
import OverlayScrollBars from "overlayscrollbars/js/jquery.overlayScrollbars.js";

var NavOverlay = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-NavOverlay',
  };

  $.extend(true, this.options, options);

};

NavOverlay.prototype.init = function () {

  var self = this;

  this.$searchTrigger = this.options.$el.find(`.${self.options.baseClass}__search`);
  this.$searchInput = this.options.$el.find(`.${self.options.baseClass}__searchForm input[type="search"]`);
  this.typeWriterTimeout = null;

  this.searchInputCleared = false;

  PubSub.subscribe('NavOverlay:show', function () {
    self.animateNavIn();
  });

  PubSub.subscribe('NavOverlay:showSearch', function () {
    self.openDirectlyToSearch();
  });

  // when close button is clicked, hide
  this.options.$el.find(`.${self.options.baseClass}__menuButton`).on('click', function () {
    self.hide();
  });

  // when search button in overlay is clicked, slide search in/out
  this.$searchTrigger.on('click', function () {

    if (self.options.$el.hasClass(`${self.options.baseClass}--animateSearchIn`) ||
      self.options.$el.hasClass(`${self.options.baseClass}--slideSearchIn`)) {
      self.slideSearchOut();
    } else {
      self.slideSearchIn();
    }

  });

  // overlay scroll bars
  this.options.$el.find(`.${self.options.baseClass}__contentColumn`).overlayScrollbars({
    className: null
  });

  this.$searchInput.on('click', function () {

    clearTimeout(self.typeWriterTimeout);

    if (!self.searchInputCleared) {
      self.$searchInput.val('');
      self.searchInputCleared = true;
    }

    self.$searchInput.focus();

  });

};

NavOverlay.prototype.animateNavIn = function () {

  var self = this;

  self.clearClasses();

  self.options.$el
    .addClass(`${self.options.baseClass}--active`)
    .addClass(`${self.options.baseClass}--animateNavIn`);

};

NavOverlay.prototype.animateNavOut = function () {

  var self = this;

  self.clearClasses();

  self.options.$el
    .addClass(`${self.options.baseClass}--active`)
    .addClass(`${self.options.baseClass}--animateNavOut`);

};

NavOverlay.prototype.openDirectlyToSearch = function () {

  var self = this

  self.clearClasses();
  self.clearSearchInput();

  self.options.$el.addClass(`${self.options.baseClass}--active`);

  window.setTimeout(function () {
    self.options.$el.addClass(`${self.options.baseClass}--animateSearchIn`);
    window.setTimeout(function () {
      self.$searchInput.focus();
    }, 100);
  }, 100);

};

NavOverlay.prototype.slideSearchIn = function () {

  var self = this

  self.clearClasses();
  self.clearSearchInput();

  self.options.$el
    .addClass(`${self.options.baseClass}--active`)
    .addClass(`${self.options.baseClass}--animateNavOut`);

  window.setTimeout(function () {
    self.options.$el.addClass(`${self.options.baseClass}--slideSearchIn`);
    window.setTimeout(function () {
      self.$searchInput.focus();
    }, 500);
  }, 300);

};

NavOverlay.prototype.slideSearchOut = function () {

  var self = this

  self.clearClasses();

  self.options.$el
    .addClass(`${self.options.baseClass}--active`)
    .addClass(`${self.options.baseClass}--slideSearchOut`);

  window.setTimeout(function () {
    self.options.$el.addClass(`${self.options.baseClass}--animateNavIn`);
  }, 300);

};

NavOverlay.prototype.clearClasses = function () {

  var self = this;

  self.options.$el
    .removeClass(`${self.options.baseClass}--active`)
    .removeClass(`${self.options.baseClass}--animateNavIn`)
    .removeClass(`${self.options.baseClass}--animateNavOut`)
    .removeClass(`${self.options.baseClass}--animateSearchIn`)
    .removeClass(`${self.options.baseClass}--slideSearchIn`)
    .removeClass(`${self.options.baseClass}--slideSearchOut`);

};

NavOverlay.prototype.hide = function () {

  var self = this;

  self.clearClasses();

};

NavOverlay.prototype.clearSearchInput = function () {

  var self = this;

  self.$searchInput.val('');
  //self.$searchInput.attr('placeholder', '');

};

// fills in the search input with a random string from the list using a typewriter effect
NavOverlay.prototype.populateSearchWithPlaceholder = function () {

  var self = this;

  var searchTerms = ['Urban Living', 'Design', 'Architecture'];

  var searchTerm = searchTerms[Math.floor(Math.random() * searchTerms.length)];
  var typeWriterChar = 1;
  var typeWriterSpeed = 70;

  this.searchInputCleared = false;

  // kick off the typewrite
  typeWriter();

  // this function calls itself recursively until the string is typed out
  function typeWriter() {

    if (typeWriterChar <= searchTerm.length) {
      self.$searchInput.val(searchTerm.slice(0, typeWriterChar));
      //self.$searchInput.attr('placeholder', searchTerm.slice(0, typeWriterChar));
      typeWriterChar++;
      self.typeWriterTimeout = setTimeout(typeWriter, typeWriterSpeed);
    }
  }

};



export default NavOverlay;